import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, App as AntdApp } from 'antd';
import { ToastProvider } from './utils/toast';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#2B803E',
      },
    }}
  >
    <AntdApp>
      <ToastProvider>
        <App />
      </ToastProvider>
    </AntdApp>
  </ConfigProvider>
);

reportWebVitals();
